import { render, staticRenderFns } from "./Teaser.vue?vue&type=template&id=7dcc3441&scoped=true"
import script from "./Teaser.vue?vue&type=script&lang=ts"
export * from "./Teaser.vue?vue&type=script&lang=ts"
import style0 from "./Teaser.vue?vue&type=style&index=0&id=7dcc3441&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcc3441",
  null
  
)

export default component.exports